
<ng-container [ngSwitch]="view">
  <div class="calendar-header">
    <span>{{ date | calendarDate:(view + 'ViewTitle'): locale}}</span>
  </div>

  <div *ngSwitchCase="'month'">
    <mwl-calendar-month-view
      [style.--monthViewFontSize]="monthViewFontSize()"
      [style.--monthViewRows]="monthViewRows()"
      [viewDate]="date"
      [events]="events()"
      [locale]="locale"
      [refresh]="refresh"
      [cellTemplate]="cellTemplate"
      (eventClicked)="onCalendarEventSelected($event)"
      (dayClicked)="onDayClicked($event.day.date)">
    </mwl-calendar-month-view>
  </div>
  <ng-container *ngSwitchCase="'week'">
    <mwl-calendar-week-view
      calendarTimeframeSelector
      [viewDate]="date"
      [daysInWeek]="daysInWeek"
      [events]="events()"
      [locale]="locale"
      [hourSegmentTemplate]="weekViewHourSegmentTemplate"
      [refresh]="refresh"
      (eventClicked)="onCalendarEventSelected($event)"
      (dayHeaderClicked)="onDayClicked($event.day.date)">
    </mwl-calendar-week-view>
  </ng-container>
  <ng-container *ngSwitchCase="'day'">
    <mwl-calendar-day-view
      calendarTimeframeSelector
      [viewDate]="date"
      [events]="events()"
      [locale]="locale"
      [hourSegmentTemplate]="weekViewHourSegmentTemplate"
      [refresh]="refresh"
      (eventClicked)="onCalendarEventSelected($event)">
    </mwl-calendar-day-view>
  </ng-container>
</ng-container>

<ng-template #customCellTemplate let-day="day" let-locale="locale">
  <div class="cal-cell-space">
  </div>
  <div class="cal-cell-top">
    <span class="cal-day-badge" *ngIf="day.badgeTotal > 0">{{ day.badgeTotal }}</span>
    <span class="cal-day-number" (click)="daySelect.emit(day.date)">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
  </div>
</ng-template>

<!-- https://github.com/mattlewis92/angular-calendar/blob/main/projects/angular-calendar/src/modules/month/calendar-month-view/calendar-month-cell/calendar-month-cell.component.ts -->
<ng-template
  #cellTemplate
  let-day="day"
  let-openDay="openDay"
  let-locale="locale"
  let-tooltipPlacement="tooltipPlacement"
  let-highlightDay="highlightDay"
  let-unhighlightDay="unhighlightDay"
  let-eventClicked="eventClicked"
  let-tooltipTemplate="tooltipTemplate"
  let-tooltipAppendToBody="tooltipAppendToBody"
  let-tooltipDelay="tooltipDelay"
  let-trackByEventId="trackByEventId"
  let-validateDrag="validateDrag"
>
  <div
    class="cal-cell-top"
    [attr.aria-label]="
      { day: day, locale: locale } | calendarA11y : 'monthCell'
    "
  >
    <span aria-hidden="true">
      <!-- <span class="cal-day-badge" *ngIf="day.badgeTotal > 0">{{
        day.badgeTotal
      }}</span> -->
      <span class="cal-day-number">{{
        day.date | calendarDate : 'monthViewDayNumber' : locale
      }}</span>
    </span>
  </div>
  <div class="cal-events" *ngIf="day.events.length > 0">
    <div
      class="cal-event"
      *ngFor="let event of day.events; trackBy: trackByEventId"
      [ngStyle]="{ backgroundColor: event.color?.primary}"
      [style.--event-borderColor]="darkenColor(event.color?.primary, 15)"
      [ngClass]="event?.cssClass"
      (mouseenter)="highlightDay.emit({ event: event })"
      (mouseleave)="unhighlightDay.emit({ event: event })"
      [mwlCalendarTooltip]="
        event.title | calendarEventTitle : 'monthTooltip' : event
      "
      [tooltipPlacement]="tooltipPlacement"
      [tooltipEvent]="event"
      [tooltipTemplate]="tooltipTemplate"
      [tooltipAppendToBody]="tooltipAppendToBody"
      [tooltipDelay]="tooltipDelay"
      mwlDraggable
      [class.cal-draggable]="event.draggable"
      dragActiveClass="cal-drag-active"
      [dropData]="{ event: event, draggedFrom: day }"
      [dragAxis]="{ x: event.draggable, y: event.draggable }"
      [validateDrag]="validateDrag"
      [touchStartLongPress]="{ delay: 300, delta: 30 }"
      (mwlClick)="eventClicked.emit({ event: event, sourceEvent: $event })"
      [attr.aria-hidden]="{} | calendarA11y : 'hideMonthCellEvents'"
    >
      <!-- <img *ngIf="event.meta?.media?.thumbnail as thumbnail"
        [src]="thumbnail"
        alt="Event Thumbnail"
        class="img-fluid rounded shadow-sm thumbnail"
      /> -->
    </div>
  </div>  
</ng-template>

<ng-template
  #weekViewHourSegmentTemplate
  let-segment="segment"
  let-locale="locale"
  let-segmentHeight="segmentHeight"
  let-isTimeLabel="isTimeLabel">
  <ng-template #timeTemplate>
    <div class="cal-time" *ngIf="isTimeLabel">
      {{ segment.date | calendarDate:'weekViewHour': locale }}
    </div>
  </ng-template>
  <div #segmentElement
        *ngSwitchCase="false"
        class="cal-hour-segment"
        [style.height.px]="segmentHeight"
        [class.cal-hour-start]="segment.isStart"
        [class.cal-after-hour-start]="!segment.isStart"
        [ngClass]="segment.cssClass"
        (pointerdown)="onSegmentMouseDown(segment, segmentElement)">
        <!--
      NOTE: Usage of PressDirective leads to some unexpected event firing patterns (at least) on android app (desktop chrome works properly),
      Reacting directly on touchstart event and implementing the required delay logic works as intended
      (onPressStart)="onSegmentPressStart(segment, segmentElement)"
      (onPressHold)="onSegmentPressHold(segment, segmentElement)">
      -->
    <ng-container *ngTemplateOutlet="timeTemplate; context: {segment, locale}"></ng-container>
  </div>
</ng-template>
